import { styled } from "goober";
import { CopyButton } from "./CopyButton";

const PreWrapper = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  &[data-fill] {
    flex: 1;
    min-height: 0;
  }
  &:hover [data-copy-button] {
    opacity: 1;
  }
`;

const Pre = styled("pre")`
  background: var(--alpha4);
  border: 0.5px solid var(--border-alpha);
  border-radius: 8px;
  padding: 16px;
  overflow: auto;
  font-family: var(--font-mono);
  font-size: 10px;
  line-height: 16px;
  color: var(--text-primary);
  margin: 0;
  &[data-fill] {
    flex: 1;
    min-height: 0;
  }
  &:not([data-fill]) {
    max-height: 200px;
  }
  &[data-wrap] {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`;

export function CodeBlock({
  content,
  fill,
  wrap,
}: {
  content: string;
  fill?: boolean;
  wrap?: boolean;
}) {
  return (
    <PreWrapper data-fill={fill || undefined}>
      <Pre data-fill={fill || undefined} data-wrap={wrap || undefined}>
        {content}
      </Pre>
      <CopyButton getText={() => content} />
    </PreWrapper>
  );
}
